import { createRoot } from 'react-dom/client';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { initMSW } from './mocks/init';
import { App } from './App';

const container = document.getElementById('root');

if (!container) {
  throw new Error('container not found!');
}
const root = createRoot(container);

(async () => {
  await initMSW();

  const LDProvider = await asyncWithLDProvider({
    clientSideID: window.env.RIDEIQ_LAUNCH_DARKLY_ID,
  });

  root.render(
    <LDProvider>
      <App />
    </LDProvider>
  );
})();
